import React, { useState } from "react";

// Import images
import leafImage from "~/assets/images/resources/leaf.png";

const ContactOne = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitForm = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Valid email is required";
    }

    if (!form.phone.trim()) {
      newErrors.phone = "Phone number is required";
    }

    if (!form.subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (!form.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("Form Submitted", form);
      // Add actual form submission logic here
    }
  };

  return (
    <section className="contact-one" style={{ marginTop: '100px',marginBottom: '100px' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-7">
              <div className="">
              <div className="block-title text-left">
                <p>CONTACTEZ-NOUS</p>
                <h3>Vous avez une question&nbsp;?</h3>
                <div className="leaf">
                  <img src={leafImage} alt="Leaf" />
                </div>
              </div>

              <form onSubmit={submitForm} className="contact-one__form">
                <div className="row low-gutters">
                  <div className="col-md-6">
                    <div className="input-group">
                      <input
                        value={form.name}
                        onChange={handleChange}
                        type="text"
                        name="name"
                        placeholder="Votre nom"
                      />
                    </div>
                    {errors.name && <span className="error">{errors.name}</span>}
                  </div>

                  <div className="col-md-6">
                    <div className="input-group">
                      <input
                        value={form.email}
                        onChange={handleChange}
                        type="email"
                        name="email"
                        placeholder="Adresse e-mail"
                      />
                    </div>
                    {errors.email && <span className="error">{errors.email}</span>}
                  </div>

                  <div className="col-md-6">
                    <div className="input-group">
                      <input
                        value={form.phone}
                        onChange={handleChange}
                        type="text"
                        name="phone"
                        placeholder="Numéro de téléphone"
                      />
                    </div>
                    {errors.phone && <span className="error">{errors.phone}</span>}
                  </div>

                  <div className="col-md-6">
                    <div className="input-group">
                      <input
                        value={form.subject}
                        onChange={handleChange}
                        type="text"
                        name="subject"
                        placeholder="Objet"
                      />
                    </div>
                    {errors.subject && <span className="error">{errors.subject}</span>}
                  </div>

                  <div className="col-md-12">
                    <div className="input-group">
                      <textarea
                        value={form.message}
                        onChange={handleChange}
                        name="message"
                        placeholder="Écrire un message"
                      />
                    </div>
                    {errors.message && <span className="error">{errors.message}</span>}
                  </div>

                  <div className="col-md-12">
                    <div className="input-group contact__btn">
                      <button type="submit" className="thm-btn contact-one__btn">
                        Envoyer le message
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="col-xl-5">
            <div
              className="have_questions"
              style={{
                background: "transparent",
                boxShadow: "none",
                padding: "40px 0 0",
              }}
            >
              <div className="block-title text-left">
                <p>CONTACTEZ-NOUS</p>
                <h3>VOUS AVEZ UNE QUESTION&nbsp;?</h3>
                <div className="leaf">
                  <img src={leafImage} alt="Leaf" />
                </div>
              </div>

              <div className="have_questions_text">
                <p>
                  Il existe de nombreuses solutions et services agricoles
                  disponibles. Notre équipe est là pour vous aider à choisir
                  les options les plus adaptées à vos besoins et à vos
                  objectifs de production.
                </p>
              </div>

              <div className="have_questions_btn">
                <a href="#contact" className="thm-btn">
                  En savoir plus
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactOne;